import { CryptJsSettingsInRegisterFav } from './../../../constant/crypt-js-settings';
import * as CryptoJS from 'crypto-js';

export class CryptJsManager {
  /** jsで暗号化
   * @param {str} string 暗号化対象文字列
   * @param {key} string 暗号化キー(暗号化の用途別に異なるので該当のものを指定のこと)
   * @param {iv} string　初期ベクトル(暗号化の用途別に異なるので該当のものを指定のこと)
   * @returns 暗号化された文字列
   */
  public static encrypt(str: string, key: string, iv: string): string {
    str = CryptoJS.enc.Utf8.parse(str);
    const encrypted = CryptoJS.AES.encrypt(str, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.ciphertext.toString();
  }

  /** jsで暗号化された文字列を復号
   * @param {str} string 復号対象文字列
   * @param {key} string 暗号化キー(暗号化の用途別に異なるので該当のものを指定のこと)
   * @param {iv} string　初期ベクトル(暗号化の用途別に異なるので該当のものを指定のこと)
   * @returns 復号された文字列
   */
  public static decrypt(str: string, key: string, iv: string): string {
    if (!str || str === '') return null;

    let encryptedHexStr = CryptoJS.enc.Hex.parse(str);
    encryptedHexStr = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    const decrypt = CryptoJS.AES.decrypt(encryptedHexStr, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
  }
}
